import {
  Box,
  Checkbox,
  Chip,
  IconButton,
  InputAdornment,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import useStyles from "../../../components/pageTitle/styles";
import invoiceIcon from "../../../assets/images/invoice.png";
import TableDesign from "../../../components/common/table/TableDesign";
import React, { useEffect, useState } from "react";
import { TableHeading } from "./customerInvoiceUntil";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  downloadInvoiceAction,
  getAllInvoiceListAction,
  setAddInvoiceResponse,
  setDeletedInvoiceResponse,
  setDownloadInvoiceAction,
  setSyncBulkInvoiceResponse,
  setUploadToQuickBookAction,
} from "../../../store/reducers/invoiceSlice";
import downloadIcon from "../../../assets/images/download.png";
import dayjs from "dayjs";
import ManageInvoice from "../invoice/ManageInvoice";
import { getColor } from "./InvoiceUntil";
import AlertPopup from "../../../components/common/alertPopup/AlertPopup";
import { setAddPaymentResponse } from "../../../store/reducers/paymentSlice";
import CustomButton from "../../../components/common/button/CustomButton";
import { formatNumberWithComma } from "../../../hooks/helper";
import {
  BackupOutlined,
  CloseOutlined,
  SearchOutlined,
} from "@mui/icons-material";
import AlertForQuickBook from "./AlertForQuickBook";
import checked from "../../../assets/check-mark1.png";
import ManageDepositInvoice from "../invoice/ManageDepositInvoice";
import FilterInvoiceForm from "./FilterInvoiceForm";
import ManageCreditInvoice from "../invoice/ManageCreditInvoice";
import { getSingleLeadAction } from "../../../store/reducers/leadSlice";
// Add this import for customer list action
import { getAllCustomerListAction } from "../../../store/reducers/invoiceSlice";
import Loader from "../../../components/common/loader/Loader";

interface FilterOption {
  search: string;
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
  customerId?: string;
  customer_email?: string;
  telephone?: string;
  startDate?: string;
  endDate?: string;
  invoiceType?: string;
  invoiceNumber?: string;
  onlyOutstanding: boolean;
  onlySynced: boolean;
}

const popupContent: any = {
  email: "Are you sure you want to send an email?",
  pdf: "Are you sure you want to download the PDF?",
  odt: "Are you sure you want to download the IDT?",
  previous: "Are you sure you want to download it?",
};

const CustomerInvoiceList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    invoices,
    invoicePaginations,
    invoiceTotalPaid,
    invoiceTotalUnpaid,
    isFileDownloaded,
    isAddInvoiceResponse,
    isDeletedInvoiceResponse,
    isUploadedToQuickBook,
    invoiceTotalAmount,
    invoiceTotalOutstanding,
    invoiceTotalPayments,
    isSyncBulkInvoiceResponse,
    isAllInvoiceListLoading,
  } = useSelector((state: any) => state.invoice);

  const { newFinancialState } = useSelector((state: any) => state?.quickBook);
  const { isAddPaymentResponse } = useSelector((state: any) => state.payment);
  const [customerFetched, setCustomerFetched] = useState(false);
  const [quickBookAlert, setQuickBookAlert] = useState(false);
  const { userProfile } = useSelector((state: any) => state?.user);

  const [isBasicDiarySection, setIsBasicDiarySection] = useState(
    userProfile?.features?.includes("Basic Work Diary") || false, // Safe fallback
  );

  const [isProfessionalSection, setIsProfessionalSection] = useState(
    userProfile?.features?.includes("Professional Financial") || false, // Safe fallback
  );

  const [selectedCustomerId, setSelectedCustomerId] = useState<any>("");

  useEffect(() => {
  try {
    const storageDetailsRaw = sessionStorage.getItem("storageDetails");
    const leadDetailsRaw = sessionStorage.getItem("leadDetails");

    // Storage details ko priority deni hai
    if (storageDetailsRaw) {
      const storageDetails = JSON.parse(storageDetailsRaw);

      setSelectedCustomerId({
        lead: {
          customer_id:
            storageDetails.customerId || storageDetails.customer?.id || "",
          customer_email: storageDetails.customer?.email || "",
          customer_name: storageDetails.customer?.name || "",
          customer_phone:
            storageDetails.customer?.telephone ||
            storageDetails.customer?.phone ||
            "",
        },
      });

      return;
    }

    // Storage details nahi hain toh existing lead details use karein
    if (leadDetailsRaw) {
      setSelectedCustomerId(JSON.parse(leadDetailsRaw));
    } else {
      setSelectedCustomerId("");
    }
  } catch (error) {
    console.error("Failed to parse session details:", error);
    setSelectedCustomerId("");
  }
}, []);

  // Ensure selected lead's customer is in the dropdown
  const { customersList } = useSelector((state: any) => state.invoice);
  useEffect(() => {
    if (
      !customerFetched &&
      selectedCustomerId?.lead?.customer_id &&
      customersList &&
      !customersList.some(
        (c: any) => c.id === selectedCustomerId.lead.customer_id,
      )
    ) {
      setCustomerFetched(true);
      // Use email or name from lead to search
      const searchParam =
        selectedCustomerId.lead.customer_email ||
        selectedCustomerId.lead.customer_name ||
        "";

      if (searchParam) {
        dispatch(
          getAllCustomerListAction({
            search: searchParam,
            customerId: selectedCustomerId.lead.customer_id,
            page: 1,
            limit: 1,
            orderBy: "created_at",
            orderIn: "DESC",
          }),
        );
      }
    }
  }, [selectedCustomerId, customersList, customerFetched]);

  useEffect(() => {
    setIsProfessionalSection(
      userProfile?.features?.includes("Professional Financial") || false,
    ); // Sync profile changes
  }, [userProfile]);

  useEffect(() => {
    if (selectedCustomerId?.lead?.customer_id) {
      setFilterOption((prev) => ({
        ...prev,
        customerId: selectedCustomerId.lead.customer_id,
        customer_email: selectedCustomerId.lead.customer_email,
        telephone: selectedCustomerId.lead.customer_phone,
        page: 1, // optional: resets page after customer change
      }));
    }
  }, [selectedCustomerId]);

  const [filterOption, setFilterOption] = useState<FilterOption>({
    search: "",
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
    customerId: "",
    customer_email: "",
    telephone: "",
    startDate: "",
    endDate: "",
    invoiceType: "",
    invoiceNumber: "",
    onlyOutstanding: false,
    onlySynced: false,
  });

  const getCleanFilter = () => {
    if (!isProfessionalSection) {
      // remove professional fields
      const {
        customerId,
        customer_email,
        telephone,
        startDate,
        endDate,
        invoiceType,
        invoiceNumber,
        onlyOutstanding,
        onlySynced,
        ...basicFilters
      } = filterOption;

      return basicFilters;
    }

    // send all filters when professional
    return filterOption;
  };

  const [isLoader] = useState(false);
  const showSyncColumn =
    newFinancialState?.accounting_package?.toLowerCase() !== "none" ||
    newFinancialState?.accounting_package === null;

  const tableHeadings: TableHeading[] = isProfessionalSection
    ? [
        { label: "Date", align: "center" as const },
        { label: "Due", align: "center" as const },
        { label: "Type", align: "center" as const },
        { label: "Inv. No.", align: "center" as const },
        { label: "Inv. Type", align: "center" as const },
        { label: "Invoice Details", align: "center" as const },
        { label: "Invoice Value (£)", align: "center" as const },
        { label: "Status", align: "center" as const },
        { label: "Payment", align: "center" as const },
        { label: "Paid On", align: "center" as const },
        { label: "Outstanding", align: "center" as const },
        // { label: "Select", align: "center" as const },
        { label: "Download", align: "center" as const },
        ...(showSyncColumn
          ? [{ label: "Accounts", align: "center" as const }]
          : [{ label: "", align: "center" as const }]),
      ]
    : [
        { label: "Number" },
        { label: "Ref. No.", align: "left" as const },
        { label: "Customer", align: "left" as const },
        { label: "Type", align: "left" as const },
        { label: "Created", align: "left" as const },
        { label: "Amount (£)", align: "left" as const },
        { label: "Due Date", align: "left" as const },
        { label: "Status", align: "left" as const },
        { label: "Download", align: "center" as const },
        ...(showSyncColumn
          ? [{ label: "Accounts", align: "center" as const }]
          : [{ label: "", align: "center" as const }]),
      ];

  useEffect(() => {
    dispatch(getAllInvoiceListAction(getCleanFilter()));
    dispatch(setAddInvoiceResponse(false));
    dispatch(setAddPaymentResponse(false));
    dispatch(setUploadToQuickBookAction(false));
    dispatch(setDeletedInvoiceResponse(false));
    dispatch(setSyncBulkInvoiceResponse(false));
    setQuickBookAlert(false);
  }, [
    filterOption.page,
    filterOption.limit,
    filterOption.orderBy,
    filterOption.orderIn,
    filterOption.search,
    filterOption.customerId,
    // filterOption.customer_email,
    filterOption.telephone,
    filterOption.startDate,
    filterOption.endDate,
    filterOption.invoiceType,
    filterOption.invoiceNumber,
    filterOption.onlyOutstanding,
    filterOption.onlySynced,
    isAddInvoiceResponse,
    isAddPaymentResponse,
    isUploadedToQuickBook,
    isProfessionalSection,
    isDeletedInvoiceResponse,
    isSyncBulkInvoiceResponse,
    dispatch,
  ]);

  const [open, setOpen] = useState(false);
  const [actionType, setActionType] = useState("");
  const [invoiceModel, setInvoiceModel] = useState(false);
  const [creditModel, setCreditModel] = useState(false);

  const handleClose = () => {
    setInvoiceModel(false);
    setCreditModel(false);
  };

  useEffect(() => {
    if (isDeletedInvoiceResponse) {
      setInvoiceModel(false);
      dispatch(setDeletedInvoiceResponse(false));
    }
  }, [isDeletedInvoiceResponse]);

  const [selectedInvoice, setSelectedInvoice]: any = useState();

  const handleDownloadInvoice = () => {
    dispatch(
      downloadInvoiceAction({
        invoice_number: selectedInvoice?.invoice_number,
        actionType: "download",
      }),
    );
  };

  useEffect(() => {
    if (isFileDownloaded) {
      dispatch(setDownloadInvoiceAction(false));
      setOpen(false);
      // setSelectedInvoice(null);
    }
  }, [isFileDownloaded]);

  const onShow = (type: any) => {
    setOpen(true);
    setActionType(type);
  };

  const onHide = () => {
    setOpen(false);
  };

  const [isNewInvoice, setIsNewInvoice] = useState(false);

  const handleInvoice = (val: any) => {
    setInvoiceModel(true);
    setSelectedInvoice(val);
    setIsNewInvoice(false);
  };

  const handleInvoiceOpen = () => {
    setInvoiceModel(true);
    setSelectedInvoice(null);
    setIsNewInvoice(true);
  };

  const handleCreditNoteOpen = () => {
    setCreditModel(true);
    setSelectedInvoice(null);
    setIsNewInvoice(true);
  };

  // inside your component
  const [selectedInvoices, setSelectedInvoices] = useState<string[]>([]);

  const handleSelectOne = (id: string) => {
    setSelectedInvoices((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const onShowQuickBookAlert = () => {
    setQuickBookAlert(true);
  };

  const handleSendInvoice = () => {
    if (selectedInvoices.length === 0) {
      alert("Please select at least one invoice to send.");
      return;
    }
    if (selectedInvoices.length > 1) {
      alert("Please select only one invoice to send at a time.");
      return;
    }
    setSelectedInvoice(
      invoices.find((inv: any) => inv.invoice_number === selectedInvoices[0]) ||
        null,
    );
    setActionType("email");
    setOpen(true);
  };
  const handleSendEmailInvoice = () => {
    const payload = {
      ...getCleanFilter(),
      action: "email",
    };

    dispatch(getAllInvoiceListAction(payload));
  };
  const handleDownloadPdf = () => {
    const payload = {
      ...getCleanFilter(),
      action: "pdf",
    };

    dispatch(getAllInvoiceListAction(payload));
  };

  return (
    <>
      {isAllInvoiceListLoading && <Loader />}
      {quickBookAlert && (
        <AlertForQuickBook
          open={quickBookAlert}
          onHide={() => setQuickBookAlert(false)}
          title="Upload to QuickBooks"
          setOpen={setQuickBookAlert}
          selectedInvoice={selectedInvoice?.invoice_number}
        />
      )}
      {invoiceModel &&
        (selectedInvoice?.invoice_type === "deposit" &&
        selectedInvoice?.invoice_type_id === null ? (
          <ManageDepositInvoice
            title={"Deposit Invoice"}
            open={invoiceModel}
            onHide={handleClose}
            invoiceType="deposit"
            isSetLeadDetails={false}
            isNewInvoice={false}
            selectedInvoice={selectedInvoice?.invoice_number}
          />
        ) : selectedInvoice?.invoice_type === "credit" ? (
          <ManageCreditInvoice
            title="Invoice"
            open={invoiceModel}
            selectedInvoice={selectedInvoice?.invoice_number}
            onHide={handleClose}
            selectedCustomerId={filterOption?.customerId || ""}
            invoiceType={selectedInvoice?.invoice_type ?? "credit"}
            isNewInvoice={isNewInvoice ?? false}
            isSetLeadDetails={true}
            isCompletionInvoice={false}
          />
        ) : (
          <ManageInvoice
            title="Invoice"
            open={invoiceModel}
            selectedInvoice={selectedInvoice?.invoice_number}
            onHide={handleClose}
            invoiceType={selectedInvoice?.invoice_type}
            isNewInvoice={isNewInvoice ?? false}
            isSetLeadDetails={true}
            isCompletionInvoice={false}
          />
        ))}
      {creditModel && (
        <ManageCreditInvoice
          title="Invoice"
          open={creditModel}
          selectedInvoice={selectedInvoice?.invoice_number}
          onHide={handleClose}
          // selectedCustomerId={filterOption?.customerId || ""}
          invoiceType={selectedInvoice?.invoice_type ?? "credit"}
          isNewInvoice={isNewInvoice ?? false}
          isSetLeadDetails={true}
          isCompletionInvoice={false}
        />
      )}
      <div className={classes.pageTitleContainer}>
        <Typography
          sx={{
            textTransform: "capitalize !important",
            display: "flex",
            alignItems: "center",
          }}
          variant={"h5"}
          fontWeight={700}
        >
          <img
            src={invoiceIcon}
            alt="invoice-icon"
            style={{ marginRight: "4px" }}
          />
          Customer Invoices
          <div
            style={{
              display: "flex",
              justifyItems: "center",
              marginLeft: "20px",
            }}
          >
            <Chip label={invoiceTotalPaid} size="small" sx={{ mr: 1 }} />
            <span
              style={{ fontSize: "13px", color: "#666666", marginTop: "3px" }}
            >
              Paid
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyItems: "center",
              marginLeft: "20px",
              fontSize: "14px",
              color: "#666666",
            }}
          >
            <Chip label={invoiceTotalUnpaid} size="small" sx={{ mr: 1 }} />
            <span
              style={{ fontSize: "13px", color: "#66666", marginTop: "3px" }}
            >
              Unpaid
            </span>
          </div>
        </Typography>
        {!isProfessionalSection && (
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <TextField
              size="small"
              placeholder="Search invoices..."
              value={filterOption.search}
              onChange={(e) =>
                setFilterOption((prev) => ({
                  ...prev,
                  search: e.target.value,
                }))
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setFilterOption((prev) => ({
                    ...prev,
                    search: filterOption.search,
                    page: 1,
                  }));
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchOutlined fontSize="small" />
                  </InputAdornment>
                ),
                endAdornment: !!filterOption.search && (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="clear search"
                      size="small"
                      onClick={() => {
                        setFilterOption((prev) => ({
                          ...prev,
                          search: "",
                          page: 1,
                        }));
                      }}
                    >
                      <CloseOutlined fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
                sx: {
                  height: "30px",
                },
              }}
              sx={{ minWidth: 260, marginTop: "0px" }}
            />
            {!isBasicDiarySection && (
              <>
                {selectedInvoices.length > 0 && (
                  <CustomButton
                    onClick={handleSendInvoice}
                    title={"Send Email"}
                  />
                )}
                <CustomButton onClick={handleInvoiceOpen} title={"Create"} />
              </>
            )}
          </div>
        )}
      </div>
      {isProfessionalSection && (
        <FilterInvoiceForm
          filterOption={filterOption}
          setFilterOption={setFilterOption}
          onHandleNewInvoice={handleInvoiceOpen}
          onHandleNewCreditNote={handleCreditNoteOpen}
          onHandleSendEmailInvoice={handleSendEmailInvoice}
          onHandleDownloadPdf={handleDownloadPdf}
          selectedInvoices={selectedInvoices}
        />
      )}
      <TableDesign
        tableHeadings={[
          { label: "", align: "center" }, // extra column for checkbox
          ...tableHeadings,
        ]}
        tableHeadColor={"#02906f"}
        cellColor={"#fff"}
        pagination={invoicePaginations}
        isLoader={isLoader}
        stickyHeader={true}
        filterOption={filterOption}
        setFilterOption={setFilterOption}
      >
        <TableRow sx={{ backgroundColor: "#eaeaea" }}>
          {/* <TableCell padding="checkbox" align="center">
            <Checkbox
              indeterminate={
                selectedInvoices.length > 0 &&
                selectedInvoices.length < invoices.length
              }
              checked={allSelected}
              onChange={handleSelectAll}
            />
          </TableCell> */}
          {/* {tableHeadings.map((th, idx) => (
            <TableCell key={idx} align={th.align || "center"}>
              {th.label}
            </TableCell>
          ))} */}
        </TableRow>
        {invoices.length > 0 ? (
          invoices?.map((val: any, idx: number) => {
            const isChecked = selectedInvoices.includes(val.invoice_number);
            return (
              <React.Fragment key={idx}>
                <TableRow
                  // key={val?.client_id}
                  sx={{
                    fontWeight: 600,
                    // border: "1px solid #d1cfcf",
                    backgroundColor: idx % 2 === 0 ? "#F9F9F9" : "#FFFFFF",
                    "&:hover": {
                      backgroundColor: "#E5F4F1",
                      cursor: "pointer",
                    },
                  }}
                >
                  <TableCell padding="checkbox" align="center">
                    <Checkbox
                      checked={isChecked}
                      onChange={() => handleSelectOne(val.invoice_number)}
                    />
                  </TableCell>
                  {/* PROFESSIONAL VIEW */}
                  {isProfessionalSection ? (
                    <>
                      <TableCell>
                        {val.invoice_date || val.created_at
                          ? dayjs(val.invoice_date || val.created_at).format(
                              userProfile?.dateFormat || "DD/MM/YYYY",
                            )
                          : ""}
                      </TableCell>
                      <TableCell>
                        {val.due_date
                          ? dayjs(val.due_date).format(
                              userProfile?.dateFormat
                                ? userProfile?.dateFormat
                                : "DD/MM/YYYY",
                            )
                          : ""}
                      </TableCell>
                      <TableCell>
                        {val.invoice_type === "credit" ? "CR" : "INV"}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          padding: "4px 0px",
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => handleInvoice(val)}
                      >
                        {val?.invoice_number}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {val.invoice_type}
                      </TableCell>
                      <TableCell sx={{ width: "360px", padding: "0px" }}>
                        {val?.description}
                      </TableCell>
                      <TableCell align="center">
                        £ {val?.invoice_type === "credit" ? "-" : ""}
                        {formatNumberWithComma(val?.total_amount)}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          textTransform: "capitalize",
                          color: getColor(val?.status),
                        }}
                      >
                        <span>{val?.status}</span>
                      </TableCell>
                      <TableCell></TableCell>
                      <TableCell align="center">
                        {val?.status?.toUpperCase() === "PAID" && val?.pay_date
                          ? dayjs(val?.pay_date).format(
                              userProfile?.dateFormat
                                ? userProfile?.dateFormat
                                : "DD/MM/YYYY",
                            )
                          : ""}
                      </TableCell>
                      <TableCell align="center">
                        {val?.invoice_type === "credit"
                          ? ""
                          : `£ ${formatNumberWithComma(
                              val?.outstanding_amount,
                            )}`}
                      </TableCell>
                      <TableCell align="center" sx={{ cursor: "pointer" }}>
                        {val?.invoice_type === "deposit" ? (
                          ""
                        ) : (
                          <img
                            style={{ cursor: "pointer" }}
                            src={downloadIcon}
                            onClick={() => {
                              onShow("pdf");
                              setSelectedInvoice(val);
                            }}
                            alt="img"
                          />
                        )}
                      </TableCell>
                      {newFinancialState?.accounting_package?.toLowerCase() !==
                        "none" && (
                        <TableCell align="center" sx={{ cursor: "pointer" }}>
                          {val.invoice_type === "deposit" ? (
                            ""
                          ) : (
                            <>
                              {!val?.is_sent_to_quickbook && (
                                <Tooltip title="Upload on QuickBooks">
                                  <BackupOutlined
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "10px",
                                    }}
                                    onClick={() => {
                                      onShowQuickBookAlert();
                                      setSelectedInvoice(val);
                                    }}
                                  />
                                </Tooltip>
                              )}

                              {val?.is_sent_to_quickbook && (
                                <Tooltip title="Already uploaded on QuickBooks">
                                  <img
                                    src={checked}
                                    style={{ width: "24px", height: "24px" }}
                                    alt="checked"
                                  />
                                </Tooltip>
                              )}
                            </>
                          )}
                        </TableCell>
                      )}
                    </>
                  ) : (
                    <>
                      <TableCell
                        align="center"
                        style={{ padding: "4px 0px", cursor: "pointer" }}
                        onClick={() => handleInvoice(val)}
                      >
                        {val?.invoice_number}
                      </TableCell>
                      <TableCell>{val?.lead_id}</TableCell>
                      <TableCell>{val?.customer_name}</TableCell>
                      <TableCell>{val.invoice_type}</TableCell>
                      <TableCell>
                        {dayjs( val?.invoice_date || val.created_at).format(
                          userProfile?.dateFormat
                            ? userProfile?.dateFormat
                            : "DD/MM/YYYY",
                        )}
                      </TableCell>
                      <TableCell>
                        £ {formatNumberWithComma(val?.total_amount)}
                      </TableCell>
                      <TableCell>
                        {dayjs(val?.due_date).format(
                          userProfile?.dateFormat
                            ? userProfile?.dateFormat
                            : "DD/MM/YYYY",
                        )}
                      </TableCell>
                      <TableCell
                        style={{
                          textTransform: "capitalize",
                          color: getColor(val?.status),
                        }}
                      >
                        <span>{val?.status}</span>
                      </TableCell>
                      <TableCell align="center" sx={{ cursor: "pointer" }}>
                        <img
                          style={{ cursor: "pointer" }}
                          src={downloadIcon}
                          onClick={() => {
                            onShow("pdf");
                            setSelectedInvoice(val);
                          }}
                          alt="img"
                        />
                      </TableCell>
                      {newFinancialState?.accounting_package?.toLowerCase() !==
                        "none" && (
                        <TableCell align="center" sx={{ cursor: "pointer" }}>
                          {val.invoice_type === "deposit" ? (
                            ""
                          ) : (
                            <>
                              {!val?.is_sent_to_quickbook && (
                                <Tooltip title="Upload on QuickBooks">
                                  <BackupOutlined
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "10px",
                                    }}
                                    onClick={() => {
                                      onShowQuickBookAlert();
                                      setSelectedInvoice(val);
                                    }}
                                  />
                                </Tooltip>
                              )}

                              {val?.is_sent_to_quickbook && (
                                <Tooltip title="Already uploaded on QuickBooks">
                                  <img
                                    src={checked}
                                    style={{ width: "24px", height: "24px" }}
                                    alt="checked"
                                  />
                                </Tooltip>
                              )}
                            </>
                          )}
                        </TableCell>
                      )}
                    </>
                  )}
                </TableRow>
                {/* -------------------- PAYMENT ROWS -------------------- */}
                {isProfessionalSection &&
                  val.payments?.length > 0 &&
                  val.payments.map((pmt: any, pIndex: number) => (
                    <TableRow
                      key={`payment-${idx}-${pIndex}`}
                      sx={{
                        backgroundColor: "#FFFFFF",
                        "&:hover": { backgroundColor: "#E5F4F1" },
                      }}
                    >
                      {/* EMPTY CELLS TO ALIGN UNDER PAYMENTS COLUMN */}
                      <TableCell></TableCell>
                      <TableCell> </TableCell>
                      <TableCell></TableCell>
                      <TableCell>Pay</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>

                      {/* PAYMENT COLUMN */}
                      <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                        £ {formatNumberWithComma(pmt.amount)}
                      </TableCell>

                      {/* OUTSTANDING (after payment) */}
                      <TableCell sx={{ textAlign: "center" }}>
                        {dayjs(pmt?.date).format(
                          userProfile?.dateFormat
                            ? userProfile?.dateFormat
                            : "DD/MM/YYYY",
                        )}
                      </TableCell>

                      {showSyncColumn && <TableCell></TableCell>}
                      {/* <TableCell></TableCell> */}
                      {/* {newFinancialState?.accounting_package?.toLowerCase() !==
                        "none" && <TableCell></TableCell>} */}
                    </TableRow>
                  ))}
              </React.Fragment>
            );
          })
        ) : (
          <TableRow>
            <TableCell colSpan={isProfessionalSection ? 14 : 9}>
              <Box
                sx={{
                  height: "60vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                <span style={{ position: "absolute" }}>Data Not Found!</span>
              </Box>
            </TableCell>
          </TableRow>
        )}
        <TableRow sx={{ background: "#ebebeb" }}>
          <TableCell colSpan={6}></TableCell>
          <TableCell
            align="center"
            style={{ fontWeight: 600, fontSize: "16px" }}
          >
            Total
          </TableCell>
          <TableCell
            align="center"
            style={{ fontWeight: 600, fontSize: "16px", whiteSpace: "nowrap" }}
          >
            £ {invoiceTotalAmount ? invoiceTotalAmount?.toFixed(2) : "0.00"}
          </TableCell>
          <TableCell></TableCell>
          <TableCell
            align="center"
            style={{ fontWeight: 600, fontSize: "16px", whiteSpace: "nowrap" }}
          >
            £ {invoiceTotalPayments ? invoiceTotalPayments?.toFixed(2) : "0.00"}
          </TableCell>
          <TableCell></TableCell>
          <TableCell
            align="center"
            style={{ fontWeight: 600, fontSize: "16px", whiteSpace: "nowrap" }}
          >
            £{" "}
            {invoiceTotalOutstanding
              ? invoiceTotalOutstanding?.toFixed(2)
              : "0.00"}
          </TableCell>
          {/* <TableCell
            align="center"
            style={{ fontWeight: 600, fontSize: "16px" }}
          ></TableCell> */}
          {newFinancialState?.accounting_package?.toLowerCase() !== "none" && (
            <TableCell></TableCell>
          )}
        </TableRow>
      </TableDesign>

      {open && (
        <AlertPopup
          open={open}
          onHide={onHide}
          title={"Invoice PDF"}
          content={popupContent[actionType]}
          submitHandler={handleDownloadInvoice}
        />
      )}
    </>
  );
};

export default CustomerInvoiceList;
